import { Module } from 'vuex';
import { IUser } from '@/interfaces/user';
import GetUserQuery from '@/graphql/queries/getUser.gql';
import { request } from '@/graphql/request';


export class UserState {
  public currentUser: IUser | null = null
}

const userModule: Module<UserState, any> = {
  namespaced: false,
  state: () => {
    const state = new UserState();
    state.currentUser = null;
    return state;
  },

  getters: {
    user: state => state.currentUser,
  },

  mutations: {
    updateUser: (state, user: IUser) => {
      state.currentUser = user;
    },
  },

  actions: {
    refreshUser: ({ commit }) => {
      request(GetUserQuery as any, {})
        .then(({ data }) => {
          commit('updateUser', data && data.getUser);
        })
        .catch(error => {
          // tslint:disable-next-line: no-console
          console.error(`Error getting user ${error}`);
          return [];
        });
    },
  },
};

export default userModule;
